import React from 'react';
import ReactPlayer from 'react-player';
import { Carousel } from 'react-responsive-carousel'

export const CarrouselProject = ({ videos, images, isMobile }) => {

    const VideoSlide = ({ url, isSelected }) => (
        <ReactPlayer url={url} playing={isSelected} controls={true} width="100%"/>
    );

    const customRenderItem = (item, props) => {
        return (
            <item.type {...item.props} {...props} />
        )
    }

    // const customRenderThumb = (children) => {
    //     children.map((item) => {
    //         // Image Thumbs
    //         if (item.props.url === undefined) return <img src={item.props.src} key={item.props.src} alt={item.props.alt}  />
    //         // Videos
    //         const videoId = item.props.url;
    //         return <img src={`https://img.youtube.com/vi/${videoId}/default.jpg`} key={videoId} alt="YouTube Video" />;
    //     });
    // }

    const baseImages = <div>{images.map((image) => {
        return ( image?.id && (
            <figure key={image.id}>
                <img src={image.url} alt={image.alt} />
                {image.decsription && (<figcaption className="legend">{image.description}</figcaption>)}
            </figure>
        ))
    })}</div>;

    const baseVideos = <div>{videos.map((video) => {
        return (
            <VideoSlide key={`video-${video.id}"`} url={video.url}/>
        )
    })}</div>;

    // const onChange = (index, item) => {
    //     console.log(item.type);
    // }
    // const onClickItem = (index, item) => {
    //     // console.log(index);
    // }
    // const onClickThumb = (index, item) => {
    //     // console.log(index);
    // }

    const isTouchEnabled = () => { 
        console.log( !!('ontouchstart' in window) || (!!('onmsgesturechange' in window) && !!window.navigator.maxTouchPoints) )
        return !!('ontouchstart' in window) || (!!('onmsgesturechange' in window) && !!window.navigator.maxTouchPoints);
    }

    const renderPrevArrow = (onClickHandler, hasPrev, label) => {
        return isTouchEnabled() ? '' : (
            hasPrev && (
                <button type="button" onClick={onClickHandler} title={label} style={{ left: 0 }} className="previous">
                </button>
            )
        )
    }
    
    const renderNextArrow = (onClickHandler, hasNext, label) => {
            return isTouchEnabled() ? '' : (
                hasNext && (
                    <button type="button" onClick={onClickHandler} title={label} style={{ right: 0 }} className="next">
                    </button>
                )
            )
    }
    
    /* If the viewport is more narrow than the breakpoint render the mobile component, else render the desktop component */
    return isMobile ?
    (
        <div className='project-carousel'>
            {baseImages.props.children}
            {baseVideos.props.children}
        </div>
    )
    : 
    (
        <Carousel
            preventMovementUntilSwipeScrollTolerance={true} 
            swipeScrollTolerance={75}
            className='project-carousel'
            dynamicHeight={false}
            autoPlay={true}
            showStatus={true}
            showArrows={true} 
            centerMode={false} 
            renderArrowPrev={renderPrevArrow}
            renderArrowNext={renderNextArrow}
            renderItem={customRenderItem}
            // renderThumbs={customRenderThumb}
            statusFormatter={(current, total) => `${current}/${total}`}
            infiniteLoop={true} showThumbs={false} showIndicators={false} 
            // onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}
        >
            {baseImages.props.children}
            {baseVideos.props.children}
        </Carousel>
    );
};